import { render, staticRenderFns } from "./RequestFreezer.vue?vue&type=template&id=98761088&"
import script from "./RequestFreezer.vue?vue&type=script&lang=js&"
export * from "./RequestFreezer.vue?vue&type=script&lang=js&"
import style0 from "./RequestFreezer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports